import { Box, Button, Typography } from "@mui/material";
import styles from "./style.module.css";
import Top from "./top";
import Image from "./image";
import { useTheme } from "../../../../../../context/themeContext";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useSwipeable } from "react-swipeable";
import { useDispatch, useSelector } from "react-redux";
import useDiscover from "../../../../../../hooks/useDiscover";
import { setFavorites } from "../../../../../../store/slices/profile/discoverSlice";

const Card = ({ project }) => {
  const { theme, darkMode } = useTheme();
  const [isFavorite, setIsFavorite] = useState(project?.shout_outed);
  const [showConfetti, setShowConfetti] = useState(false);
  const [liking, setLiking] = useState(null);
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const { deleteShoutout, handleSwipeLeft, handleSwipeRight, insertShoutout } =
    useDiscover(true);
  const { removing, favorites } = useSelector((state) => state.discover);
  const user = useSelector((state) => state.user.value);

  const handleClick = () => {
    setShowConfetti(true);
  };

  useEffect(() => {
    let fav;
    favorites.map((item) =>
      item.receiver_id === project.matched_user_id
        ? (fav = true)
        : (fav = project.shout_outed)
    );
    setIsFavorite(fav);
  }, [project]);

  const removeFav = () => {
    setIsFavorite(false);
    deleteShoutout(project);
  };

  const AddFav = () => {
    setLiking(project);
    setIsFavorite(true);
    setTimeout(() => {
      dispatch(
        setFavorites([
          ...favorites,
          { sender_id: user.id, receiver_id: project.matched_user_id },
        ])
      );
      handleClick();
      setLiking(null);
      insertShoutout(project);
    }, 100);
  };

  const handlers = useSwipeable({
    onSwipedRight: () => {
      handleSwipeLeft(project);
      AddFav();
    },
    onSwipedLeft: () => handleSwipeRight(project),
  });

  return (
    <Box
      {...handlers}
      className={`${styles.card} ${
        removing === project ? styles.removing : ""
      } ${liking === project ? styles.liking : ""}`}
      sx={{
        bgcolor: darkMode ? theme.palette.lightgrey.lightgrey400 : "#FFF",
      }}
    >
      <Top
        name={project.real_name}
        image={project.profile_image}
        project={project}
        isFavorite={isFavorite}
        setIsFavorite={setIsFavorite}
        removeFav={removeFav}
        AddFav={AddFav}
        showConfetti={showConfetti}
        setShowConfetti={setShowConfetti}
      />
      <Image image={project.skill_cover_image} />
      <Box className={styles.text}>
        <Typography
          component="h4"
          variant="body1"
          sx={{
            fontSize: "20px",
            fontWeight: "500",
            color: theme.palette.darkgrey.darkgrey600,
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            WebkitLineClamp: 1,
            textOverflow: "ellipsis",
            minHeight: "1.5em",
          }}
        >
          {`${project?.tagline || ""}`}
        </Typography>
      </Box>
      <Box
        className={styles.button}
        sx={{
          p: "8px 16px 16px",
        }}
      >
        <Button
          variant="contained"
          onClick={() => navigate(`/creators/${project?.matched_user_id}`)}
          sx={{
            textTransform: "capitalize",
            flex: "1",
            p: "10px 1.5rem",
            borderRadius: "4px",
          }}
        >
          View Creator
        </Button>
      </Box>
    </Box>
  );
};

export default Card;
